import { render, staticRenderFns } from "./majorModify.vue?vue&type=template&id=65e53160&scoped=true"
import script from "./majorModify.vue?vue&type=script&lang=ts"
export * from "./majorModify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e53160",
  null
  
)

export default component.exports